import * as Yup from "yup";

export const meterSchema = Yup.object({
  meterNumber: Yup.string().required("Required"),
  msisdn: Yup.string()
    .required("Required")
    .matches(/^[a-zA-Z0-9]+$/, "MSISDN must be alphanumeric"),
  iccid: Yup.string().matches(/^[a-zA-Z0-9]*$/, "ICCID must be alphanumeric"),
  expiry: Yup.string().required("Required"),
  model: Yup.string().required("Required"),
  propertyId: Yup.string().required("Required"),
  moreDetails: Yup.string(),
  tariff: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .nullable(),
  latitude: Yup.string()
    .required("Required")
    .matches(/^-?\d+(\.\d+)?$/, "Must be a valid coordinate")
    .test(
      "is-valid-latitude",
      "Latitude must be between -90 and 90",
      (value) => {
        if (!value) return false;
        const num = parseFloat(value);
        return num >= -90 && num <= 90;
      }
    ),
  longitude: Yup.string()
    .required("Required")
    .matches(/^-?\d+(\.\d+)?$/, "Must be a valid coordinate")
    .test(
      "is-valid-longitude",
      "Longitude must be between -180 and 180",
      (value) => {
        if (!value) return false;
        const num = parseFloat(value);
        return num >= -180 && num <= 180;
      }
    ),
  wra: Yup.boolean().required("Required"),
});
